import Model from 'flarum/common/Model';

export default class CaseFollowUp extends Model {}

Object.assign(CaseFollowUp.prototype, {
  caseId: Model.attribute('case_id'),
  userId: Model.attribute('user_id'),
  targetType: Model.attribute('target_type'),
  question: Model.attribute('question'),
  answer: Model.attribute('answer'),
  answeredBy: Model.attribute('answered_by'),
  answeredAt: Model.attribute('answered_at', Model.transformDate),
  isEditable: Model.attribute('is_editable'),
  conversationId: Model.attribute('conversation_id'),
  createdAt: Model.attribute('created_at', Model.transformDate),
  updatedAt: Model.attribute('updated_at', Model.transformDate),

  case: Model.hasOne('case'),
  user: Model.hasOne('user'),
});
